import React from 'react';
import { MenuItem } from '@mui/material';
import { IoMdCheckmark } from 'react-icons/io';

interface OverrideMenuItemProps {
  isChecked: boolean;
  key: React.Key;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
  optionName: string;
  isDisabled: boolean;
  menuStyle: React.CSSProperties;
}

const OverrideMenuItem: React.FC<OverrideMenuItemProps> = ({
  isChecked,
  key,
  onClick,
  optionName,
  isDisabled,
  menuStyle,
}) => {
  return (
    <div style={{ display: "flex" }} key={key}>
      <span
        style={{
          color: "rgb(211, 211, 211)",
          paddingLeft: "5px",
          paddingTop: "4px",
          position: "absolute",
        }}
      >
        {isChecked ? <IoMdCheckmark style={{ color: "#7c7979" }} /> : null}
      </span>
      <MenuItem
        onClick={onClick}
        disabled={isDisabled}
        sx={{
          ...menuStyle,
          width: "100%",
        }}
      >
        {optionName}
      </MenuItem>
    </div>
  );
};

export default OverrideMenuItem;
